import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import { TokenService } from '@/services/storage.service'
import ApiService from '@/services/api.service'

import Home from '../views/Home.vue'
import ForgotPassword from '../views/ForgetPassword.vue'

import Dashboard from '../views/Authenticated/Dashboard.vue'

import LogisticsDashBoard from '../views/Authenticated/Logistics/Logistics_dashboard.vue'
import Profile from '../views/Authenticated/Account/Profile.vue'

import WebPage from '../views/Authenticated/Admin/webpage.vue'
import Permission from '../views/Authenticated/Admin/permission.vue'
import Account from '../views/Authenticated/Admin/account.vue'
import webpage_tag from '../views/Authenticated/Admin/webpage_tag.vue'
import admin_dashboard from '../views/Authenticated/Admin/admin_dashboard.vue'
import worker_type from '../views/Authenticated/Admin/worker_type.vue'
import worker_status from '../views/Authenticated/Admin/worker_status.vue'
import file_status from '../views/Authenticated/Admin/file_status.vue'
import worker_leave_type from '../views/Authenticated/Admin/worker_leave_type.vue'

import hr_worker from '../views/Authenticated/HR/hr_worker.vue'
import hr_new_worker from '../views/Authenticated/HR/hr_new_worker.vue'
import hr_view_worker from '../views/Authenticated/HR/hr_view_worker.vue'
import hr_attendence from '../views/Authenticated/HR/hr_attendence.vue'
import hr_generate_report from '../views/Authenticated/HR/hr_generate_report.vue'

Vue.use(Vuelidate)
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      public: true
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgetPassword',
    component: ForgotPassword,
    meta: {
      public: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/log-dashboard',
    name: 'Logistics_dashboard',
    component: LogisticsDashBoard
  },
  {
    path: '/admin_dashboard',
    name: 'admin_dashboard',
    component: admin_dashboard
  },
  {
    path: '/webpage',
    name: 'WebPage',
    component: WebPage
  },
  {
    path: '/webpage_tag',
    name: 'webpage_tag',
    component: webpage_tag
  },
  {
    path: '/worker_type',
    name: 'worker_type',
    component: worker_type
  },
  {
    path: '/file_status',
    name: 'file_status',
    component: file_status
  },
  {
    path: '/worker_status',
    name: 'worker_status',
    component: worker_status
  },
  {
    path: '/worker_leave_type',
    name: 'worker_leave_type',
    component: worker_leave_type
  },
  {
    path: '/permission',
    name: 'Permission',
    component: Permission
  },
  {
    path: '/Account',
    name: 'Account',
    component: Account
  },

  {
    path: '/hr_worker',
    name: 'hr_worker',
    component: hr_worker
  },
  {
    path: '/hr_new_worker',
    name: 'hr_new_worker',
    component: hr_new_worker
  },
  {
    path: '/hr_attendence',
    name: 'hr_attendence',
    component: hr_attendence
  },
  {
    path: '/hr_generate_report',
    name: 'hr_generate_report',
    component: hr_generate_report
  },
  {
    path: '/hr_view_worker/:id',
    name: 'hr_view_worker',
    component: hr_view_worker,
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const token = !!TokenService.getToken()
  if (isPublic) {
    TokenService.removeToken()
  }
  if (!isPublic && token == false) {
    return next('/')
  } else {
    if (!isPublic) {
      if (TokenService.getToken()) {
        ApiService.setHeader()
      }
      ApiService.get('/Authentication').then(res => {
        if (!res.data.isauthenticated) {
          ApiService.removeHeader()
          return next('/')
        } else {
          if(router.history.current.name !== "Dashboard" && router.history.current.name !== "Profile"){
          ApiService.get('/Authentication/' + router.history.current.name).then(res => {
            if (!res.data.isauthenticated) {
              ApiService.removeHeader()
              return next('/')
            } else {
              if (!res.data.success) {
                ApiService.removeHeader()
                return next('/')
            }
          }
          })
        }
        }
      })
    }
  }
  return next(vm => {
    vm.prevRoute = from
  })
})

export default router
